import { render, staticRenderFns } from "./edit-point.vue?vue&type=template&id=474213a6"
import script from "./edit-point.vue?vue&type=script&lang=js"
export * from "./edit-point.vue?vue&type=script&lang=js"
import style0 from "./edit-point.vue?vue&type=style&index=0&id=474213a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports